import { defineMessages } from '@atlassian/jira-intl';

const messages = defineMessages({
	title: {
		id: 'portfolio-3-onboarding.tmp-cross-project-parenting.title',
		defaultMessage:
			'You can now assign a company managed {initiatives} as a parent to a team managed {epics}.',
		description:
			'This title is for flag which is use to inform user about the new capability to add parent to Team managed project epics.',
	},
	iconLabel: {
		id: 'portfolio-3-onboarding.tmp-cross-project-parenting.icon-label',
		defaultMessage: 'New Feature',
		description: 'ARIA label for the new feature icon.',
	},
});

export default messages;
